import { render, staticRenderFns } from "./MainContent.vue?vue&type=template&id=3c727a0c&scoped=true"
import script from "./MainContent.vue?vue&type=script&lang=js"
export * from "./MainContent.vue?vue&type=script&lang=js"
import style0 from "./MainContent.vue?vue&type=style&index=0&id=3c727a0c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c727a0c",
  null
  
)

export default component.exports